module.exports = {"contact":{"nombre_eleves":["Nombre d'élèves","Number of students"],"nombre_cours":["Nombre de cours","Number of courses"],"button_view_schools":["Voir les écoles","Discover the schools"]}}


//////////////////
// WEBPACK FOOTER
// ./src/features/About/translations/translations_about.json
// module id = 1495
// module chunks = 0